export default __webpack_public_path__ + "static/media/bg.638bb306.png";